import { useSessionStore } from './index';
import type { SessionStore } from '../auth/sessionService';
import { getCurrentEnv } from './apiUrlResolver';

const ANON_KEY = 'extend_id';

const getPrefix = (): string => {
  const env = getCurrentEnv();
  if (env === 'prd') return '';
  if (env === 'local') return 'local-';
  return env ? `${env}-` : '';
};

const generateId = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
};

const useVisitorId = (): string | undefined => {
  const { isAuthenticated, akaname } = useSessionStore((store: unknown) => {
    const sessionStore = store as SessionStore;
    return {
      isAuthenticated: sessionStore.isAuthenticated,
      akaname: sessionStore.user?.akaname as string | undefined,
    };
  });

  const prefix = getPrefix();

  // Auth state not resolved yet — wait
  if (isAuthenticated === null) return undefined;

  // Authenticated — wait for user data
  if (isAuthenticated) {
    return akaname ? `${prefix}${akaname}` : undefined;
  }

  // Not authenticated — anonymous ID
  let anonId = localStorage.getItem(ANON_KEY);
  if (!anonId) {
    anonId = `extend-${generateId()}`;
    localStorage.setItem(ANON_KEY, anonId);
  }
  return `${prefix}${anonId}`;
};

export default useVisitorId;
